import { render, staticRenderFns } from "./AiChatModal.vue?vue&type=template&id=34f4dd7a&scoped=true&"
import script from "./AiChatModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiChatModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f4dd7a",
  null
  
)

export default component.exports